import { render, staticRenderFns } from "./Spend.vue?vue&type=template&id=06f5e441&scoped=true"
import script from "./Spend.vue?vue&type=script&lang=js"
export * from "./Spend.vue?vue&type=script&lang=js"
import style0 from "./Spend.vue?vue&type=style&index=0&id=06f5e441&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5e441",
  null
  
)

export default component.exports